import styled from "styled-components";

export const CustomEye = styled.img`
  cursor: pointer;
  filter: brightness(0) saturate(100%) invert(13%) sepia(4%) saturate(8%)
    hue-rotate(352deg) brightness(93%) contrast(84%);
`;
